import apiClient from '../../../../core/Api';
import { TagType, TagRequestParams } from '../../../../data/types/tags.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class EventService {
  static create = async (reqParams: TagRequestParams): Promise<TagType> =>
    apiClient.post(`${API_BASE_URL}/events`, reqParams).then((response) => response.data);

  static get = async (): Promise<TagType[]> =>
    apiClient.get(`${API_BASE_URL}/events`).then((response) => {
      const { data } = response;
      return data.rows;
    });

  static deleteEvents = async (ids: number[]): Promise<boolean> => {
    const response = await apiClient.delete(`${API_BASE_URL}/events/${ids}`);
    return response.status === 204;
  };
}

export default EventService;
